import React, { HTMLAttributes } from 'react';

import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Container, TitleWithText } from '@uncinc/uncinc-react-kitchen-sink';

import { DownloadButton } from '../../../components';
import { ParagraphDownloads as Type } from '../../../types/uncinc_profile/paragraphs';

interface ParagraphDowloadsProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphDownloads: React.FC<ParagraphDowloadsProps> = ({ entity }) => {
  const paragraphDownloads = entity.toJS();

  const uuid = paragraphDownloads.uuid[0].value;
  const title = paragraphDownloads.field_title[0]?.value;
  const body = paragraphDownloads.field_body[0]?.processed;
  const downloads = paragraphDownloads.field_downloads;

  const downloadItems = downloads.map((download) => (
    {
      source: download.entity?.field_media_document[0].source ?? '',
      title: download.entity?.name[0].value ?? '',
      filename: download.entity?.field_media_document[0].filename ?? '',
      filesize: download.file_size,
      mime: download.mime_type,
    }
  ));

  return (
    <div id={uuid} className="ParagraphDownloads">
      <Container>
        <TitleWithText
          title={title}
          text={body}
        />

        <div className="ParagraphDownloads__downloads u-flex--column u-gap--3">
          {downloadItems.map((download) => (
            <DownloadButton {...download} />
          ))}
        </div>
      </Container>
    </div>
  );
};

export default ParagraphDownloads;
